import { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../shared/context/auth-context';
import './menuItems.css'

export default function HeaderMenu() {
    const { logout ,deviceType} = useAuthContext();
    const location = useLocation();
    const [keyPath, setKeyPath] = useState('')

    const menuItems = [
        {
            title: "Οι διαδρομές μου",
            key: "1",
            link: <Link to="/" />
        },
        {
            title:  deviceType==="mobile"? "Οδηγίες Beacon συσκευής":"Οδηγίες OBD συσκευής",
            key: "2",
            link: <Link to="/guide" />
        },
        {
            title: "Αλλαγή στοιχείων πρόσβασης",
            key: "3",
            link: <Link to="/profile" />
        },
        {
            title: "Αποσύνδεση",
            key: "4",
            onClick: () => { logout() }
        }
    ]

    useEffect(() => {
        menuItems.forEach((item) => location.pathname === item.link?.props?.to ? setKeyPath(item.key.toString()) : null)
    }, [location]);

    const classNameMenu = ".ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected"

    return (
        <Menu selectedKeys={keyPath} mode="horizontal" className={classNameMenu} >
            {menuItems.map((menuItem) =>
                <Menu.Item key={menuItem.key} onClick={menuItem.onClick}>
                    {menuItem.link}{menuItem.title}
                </Menu.Item>
            )}
        </Menu>
    )
}

